import React from "react";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  TextField,
  Typography,
  Box
} from "@material-ui/core";

const ConceptosEditV2 = ({ conceptos, onDescChange, totales, disabled }) => {
  return (
    <Box>
      <TableContainer component={Paper} elevation={2}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Código</strong></TableCell>
              <TableCell><strong>Clave SAT</strong></TableCell>
              <TableCell><strong>Descripción</strong></TableCell>
              <TableCell align="right"><strong>P. Unitario</strong></TableCell>
              <TableCell align="right"><strong>Importe</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conceptos.map((concepto, index) => (
              <TableRow key={concepto.concepto || index}>
                <TableCell>{concepto.concepto}</TableCell>
                <TableCell style={{ fontStyle: "italic", color: "#666" }}>
                  {concepto.producto || "N/A"}
                </TableCell>
                <TableCell style={{ width: "50%" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={concepto.descripcion}
                    onChange={(e) => onDescChange(index, e.target.value)}
                    disabled={disabled}
                    inputProps={{ maxLength: 1000 }}
                  />
                </TableCell>
                <TableCell align="right">${parseFloat(concepto.importe || 0).toFixed(2)}</TableCell>
                <TableCell align="right">${parseFloat(concepto.importe || 0).toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={3} display="flex" justifyContent="flex-end">
        <Paper elevation={1} style={{ padding: 15, width: 300 }}>
          <Typography variant="h6" gutterBottom>Resumen</Typography>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">Subtotal:</Typography>
            <Typography variant="body2">${parseFloat(totales.subtotal || 0).toFixed(2)}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">IVA (16%):</Typography>
            <Typography variant="body2">${parseFloat(totales.iva || 0).toFixed(2)}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">Retención (4%):</Typography>
            <Typography variant="body2" color="error">-${parseFloat(totales.retencion || 0).toFixed(2)}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mt={2} pt={1} style={{ borderTop: "1px solid #eee" }}>
            <Typography variant="subtitle1"><strong>Total:</strong></Typography>
            <Typography variant="subtitle1"><strong>${parseFloat(totales.total || 0).toFixed(2)}</strong></Typography>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default ConceptosEditV2;
